import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import FontAwesome from 'react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

import colours from '~/utils/colours';
import { createFontAwesomeIcon } from '~/App/Components/Attributes/util';

const PageSpinnerContainer = styled.div`
  height: 100%;
  display: flex;
`;

interface SpinnerProps {
  className?: string;
  loadingText?: string;
  theme?: { color: string };
  style?: Record<string, string>;
}

const Container = styled.span`
  color: ${({ theme }: SpinnerProps) => theme?.color};
`;

const Spinner = ({
  className,
  loadingText = 'Loading...',
  theme = {
    color: colours.grey,
  },
  style = {},
}: SpinnerProps) => (
  <Container className={className} theme={theme} style={style}>
    <FontAwesome name='spinner' className='fa-spin' /> {loadingText}
  </Container>
);

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export function PageSpinner() {
  return (
    <PageSpinnerContainer>
      <Spinner style={{ margin: 'auto' }} />
    </PageSpinnerContainer>
  );
}

export const SpinnerNew = styled(createFontAwesomeIcon(faSpinner))`
  animation: ${rotate360} 2s linear infinite;
`;

export default Spinner;
